import { motion } from "framer-motion";

const SCREENSHOTS = [
  "https://framerusercontent.com/images/GHMmQx9IPVa5BxWoItXhhMTlbEI.png",
  "https://framerusercontent.com/images/b6hnfackCryFKkZufGvyqjwdM.png",
  "https://framerusercontent.com/images/Lg5XRzEkzb77efoxomreatnMeU.png",
  "https://framerusercontent.com/images/KOQvisi0mweK0f9r63qZYtKptM.png",
  "https://framerusercontent.com/images/rlndeeKbKBIZEzWF96LT736ZL3g.png",
  "https://framerusercontent.com/images/BJyzxGeqwWpwhoG1l3z9e2rzvl8.png",
  "https://framerusercontent.com/images/PuoY72YnNWX7NGsehaFb7QOZdLg.png",
];

export default function Screenshots() {
  const doubled = [...SCREENSHOTS, ...SCREENSHOTS];

  return (
    <section
      data-testid="screenshots-section"
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mb-16 sm:mb-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mx-auto text-center"
        >
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#B47CE8] font-semibold mb-4">
            Aperçu
          </span>
          <h2
            data-testid="screenshots-title"
            className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-white leading-[1.05]"
          >
            Découvre l&apos;application
          </h2>
        </motion.div>
      </div>

      <div className="marquee-container marquee-fade relative">
        <div className="marquee-track gap-6 sm:gap-8 px-6" data-testid="screenshots-marquee">
          {doubled.map((src, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-[220px] sm:w-[260px] md:w-[280px]"
              aria-hidden={i >= SCREENSHOTS.length ? "true" : "false"}
            >
              <div className="relative rounded-[36px] overflow-hidden shadow-[0_20px_80px_-20px_rgba(157,76,221,0.4)] ring-1 ring-white/10">
                <div className="absolute inset-0 bg-gradient-to-b from-white/[0.04] to-transparent pointer-events-none z-10" />
                <img
                  src={src}
                  alt={`Aperçu Echo ${(i % SCREENSHOTS.length) + 1}`}
                  className="w-full h-auto block"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
